// extracted by mini-css-extract-plugin
export default {"main":"on-exchange_main__FpFRR","title":"on-exchange_title__H9H3H","items":"on-exchange_items__ayU+r","other":"on-exchange_other__tQUjs"};